module.exports = __webpack_public_path__ + "static/media/trash.577aaec0.png";